"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkSunSpider = void 0;
const BenchmarkBase_1 = require("./BenchmarkBase");
class BenchmarkSunSpider extends BenchmarkBase_1.BenchmarkBase {
    createStartFunctionCode(code) {
        const sunSpiderCPUWarmup = `
            var warmupMS = 20;
            for (var start = Date.now(); Date.now() - start < warmupMS;) {
                for (var i = 0; i < 100; ++i) {
                    if (Math.atan(Math.acos(Math.asin(Math.random()))) > 4) {
                        return;
                    }
                }
            }        
            `;
        return `
            ${sunSpiderCPUWarmup}

            var __data = {sum: 0, n: 0};
            for (var i = 0; i < 20; ++i) {
                var __time_before = Date.now();
                ${code}
                var __time_after = Date.now();
                __data.sum += Math.max(__time_after - __time_before, 1);
                ++__data.n;
            }
            return __data.sum / __data.n;
        `;
    }
}
exports.BenchmarkSunSpider = BenchmarkSunSpider;
//# sourceMappingURL=BenchmarkSunSpider.js.map